
{
  "label": "Menu Item",
  "placeholder": "Search for menu item",
  "no-data": "No menu items found",
  "errors": {
    "load": "Unable to load items"
  }
}
